import React, { useState } from 'react';
import './ProjectCard.css';
import TechContainer from '../TechContainer/TechContainer';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useHistory } from 'react-router';

const ProjectCard = (props) => {
        const { project } = props;
        const { name, description, live, github_client, img1, img2, img3, id } = props.project;

        const settings = {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
        };

        // Project Details Routing and Function:
        const history = useHistory();
        const projectDetails = () => {
                history.push(`/project/${id}`);
        }

        return (
                <div className="project-card container mt-4">
                        <div>
                                <div className="row"
                                        data-aos="fade-right"
                                        data-aos-offset="300"
                                        data-aos-easing="ease-in-sine"
                                >
                                        <div className="col-lg-6">
                                                <div className="row m-0 p-0 brand-border">
                                                        <Slider {...settings}>
                                                                <div>
                                                                        <img className="img-fluid border border-3 border-dark rounded-3" src={img1} alt="" />
                                                                </div>
                                                                <div>
                                                                        <img className="img-fluid border border-3 border-dark rounded-3" src={img2} alt="" />
                                                                </div>
                                                                <div>
                                                                        <img className="img-fluid border border-3 border-dark rounded-3" src={img3} alt="" />
                                                                </div>
                                                        </Slider>
                                                </div>
                                                <div className="row m-0 p-0">
                                                        <div className="text-center brand-color fw-bold">
                                                                <div>
                                                                        <small className="d-block m-0 p-0">_______
                                                                        </small>
                                                                        <small className="d-block m-0 p-0">_____________</small>
                                                                        <small className="d-block m-0 p-0">____________________</small>
                                                                </div>
                                                        </div>
                                                </div>
                                                {/* <div>
                                                        <h6 className="text-center mt-3 brand-color fw-bold">{name}</h6>
                                                </div> */}
                                        </div>
                                        <div className="col-lg-6 p-3">
                                                <div className="d-flex justify-content-between">
                                                        <h3 className="fw-bold project-title">{name}</h3>
                                                        <h5 className="fw-bold brand-color">{id}</h5>
                                                </div>
                                                <p>{description}</p>
                                                {
                                                        project?.technologies?.map(tec =>
                                                                <TechContainer
                                                                        tec={tec}
                                                                >

                                                                </TechContainer>)
                                                }
                                                <div className="text-center">
                                                        <a href={live} target="_blank">
                                                                <button className="btn brand-btn  fw-bolder ms-3 mt-5">
                                                                        <i className="fas fa-globe"></i> Website
                                                                </button>
                                                        </a>
                                                        {/* <div className="mt-5">
                                                                <a className="special-btn" href={live} target="_blank">
                                                                        <span>Website</span> <i></i>
                                                                </a>
                                                        </div> */}
                                                        <a href={github_client} target="_blank">
                                                                <button className="ms-3 btn brand-btn  fw-bolder mt-5">
                                                                        <i className="fab fa-github"></i> GitHub
                                                                </button>
                                                        </a>
                                                        {/* <div className="mt-5">
                                                                <a className="ms-2 special-btn" href={github_client} target="_blank">
                                                                        <span>GitHub</span> <i></i>
                                                                </a>
                                                        </div> */}
                                                        <button onClick={projectDetails} className="ms-3 btn brand-btn  fw-bolder mt-5">
                                                                <i class="fas fa-info-circle"></i> Details
                                                        </button>
                                                        {/* <div className="mt-5">
                                                                <a className="special-btn ms-2" href="" onClick={projectDetails} >
                                                                        <span>Details</span> <i></i>
                                                                </a>
                                                        </div> */}
                                                </div>
                                        </div>
                                </div>
                        </div>
                </div >
        );
};

export default ProjectCard;